export default __webpack_public_path__ + "static/media/kdabra.b845c05b.svg";